/**
 * WebSite Schema (JSON-LD)
 *
 * Defines the website structure for search engines and AI systems.
 * https://schema.org/WebSite
 */

export const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'LinkPool',
  url: 'https://linkpool.com',
  description:
    "LinkPool is leading the crypto ecosystem's next evolution with enterprise-grade Web3 infrastructure, liquid staking, and onchain finance solutions.",
  publisher: {
    '@type': 'Organization',
    name: 'LinkPool',
    url: 'https://linkpool.com',
    logo: {
      '@type': 'ImageObject',
      url: 'https://linkpool.com/brand-assets/linkpool-logo-white.png'
    }
  },
  inLanguage: 'en',
  copyrightYear: 2017,
  keywords: [
    'LinkPool',
    'Web3',
    'Crypto',
    'Blockchain',
    'Liquid Staking',
    'Enterprise',
    'Decentralised',
    'Onchain Finance'
  ]
}
